var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.4117V9.87955C20 9.32571 19.7478 8.80727 19.2789 8.45628C18.0466 7.53394 15.5391 5.70073 13.5439 4.07129C12.6534 3.34407 11.2998 3.29814 10.3929 4.00828L4.79819 8.3895C4.29157 8.78623 4 9.36541 4 9.97503V18.4117C4 19.5651 5.02335 20.5 6.28571 20.5H6.85714C8.11951 20.5 9.14286 19.5651 9.14286 18.4117V16.3235C9.14286 15.1702 10.1662 14.2352 11.4286 14.2352H12.5714C13.8338 14.2352 14.8571 15.1702 14.8571 16.3235V18.4117C14.8571 19.5651 15.8805 20.5 17.1429 20.5H17.7143C18.9767 20.5 20 19.5651 20 18.4117Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.3612ed5c5b2868927fc3a0f76daa51ea.svg";
export { ForwardRef as ReactComponent };